import { useState } from 'react';

const MAP_IMAGE = "https://hosting.photobucket.com/d970c25b-dfba-4164-a867-030817bbaa89/ab7bbe9b-cd36-4777-b8f7-02ce6e65ea8b.png";

const CoordinateTool = () => {
  const [clicks, setClicks] = useState([]);
  const [lastClick, setLastClick] = useState(null);

  const handleClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    
    const coord = { x: Math.round(x * 10) / 10, y: Math.round(y * 10) / 10 };
    setLastClick(coord);
    setClicks(prev => [...prev, coord]);
  };

  const copyAll = () => {
    const text = clicks.map((c, i) => `Sticker ${i + 1}: x: ${c.x}, y: ${c.y}`).join('\n');
    navigator.clipboard.writeText(text);
    alert('Coordenadas copiadas!');
  };

  const reset = () => {
    setClicks([]);
    setLastClick(null);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-2xl font-bold mb-4 text-center">Herramienta de Coordenadas</h1>
        
        <div className="bg-white p-4 rounded-lg shadow mb-4">
          <p className="text-sm text-gray-600 mb-2">
            <strong>Instrucciones:</strong> Haz click en el CENTRO de cada token amarillo numerado (1, 2, 3... hasta 10) en orden.
          </p>
          {lastClick && (
            <p className="text-lg font-mono bg-green-100 p-2 rounded">
              Último click: <strong>x: {lastClick.x}, y: {lastClick.y}</strong>
            </p>
          )}
        </div>

        {/* Map with click handler */}
        <div 
          className="relative cursor-crosshair rounded-lg overflow-hidden shadow-lg"
          onClick={handleClick}
        >
          <img 
            src={MAP_IMAGE}
            alt="Mapa"
            className="w-full h-auto"
            draggable={false}
          />
          
          {/* Show click markers */}
          {clicks.map((click, index) => (
            <div
              key={index}
              className="absolute w-6 h-6 bg-red-500 rounded-full border-2 border-white flex items-center justify-center text-white text-xs font-bold transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
              style={{ left: `${click.x}%`, top: `${click.y}%` }}
            >
              {index + 1}
            </div>
          ))}
        </div>

        {/* Coordinates list */}
        <div className="mt-4 bg-white p-4 rounded-lg shadow">
          <div className="flex justify-between items-center mb-2">
            <h2 className="font-bold">Coordenadas ({clicks.length}/10)</h2>
            <div className="space-x-2">
              <button 
                onClick={reset}
                className="px-3 py-1 bg-red-500 text-white rounded text-sm hover:bg-red-600"
              >
                Reiniciar
              </button>
              <button 
                onClick={copyAll}
                className="px-3 py-1 bg-blue-500 text-white rounded text-sm hover:bg-blue-600"
                disabled={clicks.length === 0}
              >
                Copiar Todo
              </button>
            </div>
          </div>
          
          <div className="font-mono text-sm bg-gray-50 p-3 rounded max-h-60 overflow-y-auto">
            {clicks.length === 0 ? (
              <p className="text-gray-400">Haz click en los tokens del mapa...</p>
            ) : (
              clicks.map((click, index) => (
                <div key={index} className="py-1 border-b border-gray-200 last:border-0">
                  <span className="text-blue-600">Sticker {index + 1}:</span> x: {click.x}, y: {click.y}
                </div>
              ))
            )}
          </div>
        </div>

        <p className="text-center text-sm text-gray-500 mt-4">
          Cuando termines los 10 clicks, copia las coordenadas y pégamelas en el chat.
        </p>
      </div>
    </div>
  );
};

export default CoordinateTool;
